"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _link = require("../../constants/link");

var _LinkPreview = _interopRequireDefault(require("./LinkPreview"));

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.links." + suffix;
};

var EditLinkPopoverPreview =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(EditLinkPopoverPreview, _Component);

  function EditLinkPopoverPreview() {
    (0, _classCallCheck2.default)(this, EditLinkPopoverPreview);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EditLinkPopoverPreview).apply(this, arguments));
  }

  (0, _createClass2.default)(EditLinkPopoverPreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          href = _this$props.href,
          onEdit = _this$props.onEdit,
          onUnlink = _this$props.onUnlink,
          linkType = _this$props.linkType,
          linkDisplayName = _this$props.linkDisplayName,
          onAnchorPreviewClick = _this$props.onAnchorPreviewClick;
      return _react.default.createElement(_UIFlex.default, {
        align: "center",
        justify: "center",
        className: "link-popover-option"
      }, _react.default.createElement(_UIBox.default, null, _react.default.createElement(_UILink.default, {
        onMouseDown: function onMouseDown(event) {
          // Prevent default to avoid blurring inline editor in FF
          event.preventDefault();
        },
        onClick: onEdit,
        truncate: true,
        iconProps: {
          style: {
            height: 0
          }
        }
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('edit')
      }))), _react.default.createElement(_UIBox.default, {
        className: "p-left-3 m-left-3 popover-preview__tail-node"
      }, _react.default.createElement(_UILink.default, {
        onMouseDown: function onMouseDown(event) {
          // Prevent default to avoid blurring inline editor in FF
          event.preventDefault();
        },
        onClick: onUnlink
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('remove')
      }))), _react.default.createElement(_LinkPreview.default, {
        className: "p-left-3 m-left-3 popover-preview__tail-node",
        linkType: linkType,
        href: href,
        linkDisplayName: linkDisplayName,
        onAnchorPreviewClick: onAnchorPreviewClick
      }));
    }
  }]);
  return EditLinkPopoverPreview;
}(_react.Component);

exports.default = EditLinkPopoverPreview;
EditLinkPopoverPreview.propTypes = {
  href: _react.PropTypes.string.isRequired,
  onEdit: _react.PropTypes.func.isRequired,
  onUnlink: _react.PropTypes.func.isRequired,
  linkType: _react.PropTypes.oneOf((0, _link.getAllLinkTypesForProps)()).isRequired,
  linkDisplayName: _react.PropTypes.string.isRequired,
  onAnchorPreviewClick: _react.PropTypes.func
};
module.exports = exports.default;